import { render, staticRenderFns } from "./ContasBancariasPaginacao.vue?vue&type=template&id=0921d452"
import script from "./ContasBancariasPaginacao.vue?vue&type=script&lang=js"
export * from "./ContasBancariasPaginacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports